module.exports = __webpack_public_path__ + "static/img/banner-home.0e5539c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplyFinance/banner-home.png
// module id = nZBt
// module chunks = 44